import { supabase } from './database/supabase';

export interface Lead {
  id: string;
  name: string;
  email: string;
  phone: string;
  created_at?: string;
}

class LeadService {
  async saveLead(lead: Omit<Lead, 'id' | 'created_at'>) {
    try {
      const { data, error } = await supabase
        .from('leads')
        .insert([{
          name: lead.name,
          email: lead.email,
          phone: lead.phone
        }])
        .select()
        .single();

      if (error) {
        console.error('Erro ao salvar lead:', error);
        throw error;
      }

      return data;
    } catch (error) {
      console.error('Erro no saveLead:', error);
      throw error;
    }
  }

  async getLeads() {
    try {
      const { data, error } = await supabase
        .from('leads')
        .select('*')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data;
    } catch (error) {
      console.error('Erro ao buscar leads:', error);
      throw error;
    }
  }
}

export const leadService = new LeadService();
